<template>
  <!-- カテゴリー一覧 -->
  <CreatePlusCategory id="app_category"/>
</template>

<script>
import CreatePlusCategory from '../components/CreatePlusCategory'

export default {
  name: "CreatePlusAppTop",
  props: {
  },
  components: {
    CreatePlusCategory
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT,
    };
  },
  metaInfo() {
    return {
      title: "Epson Setup Navi",
      meta: [
        {
          name: "description",
          content: this.$store.state.messages.messages["0-141"],
        },
      ],
      link: [
        {
          rel: "stylesheet",
          href:
            process.env.VUE_APP_ROOT + "/assets/createplus/css/createplus.css",
        },
        {
          rel: "stylesheet",
          href: "https://maxcdn.bootstrapcdn.com/font-awesome/4.3.0/css/font-awesome.min.css",
        },
      ],
    };
  },
};
</script>

<style scoped>
#app_category {
  margin-top: 15px;
}
</style>